module.exports = __webpack_public_path__ + "static/media/view_all@2x.ef089bb4.svg";